import styles from './FJLibrary.module.less';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJHeader from './FJHeader.jsx';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJVoiceItemContainer from '../container/FJVoiceItemContainer.jsx';
import FJSelectWithSearch from '../../../FJTextToVideo/FJVoiceSetting/FJSelectWithSearch/FJSelectWithSearch.jsx';
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import FJConstant from '../../../../constants/FJConstant.js';

const FJLibrary = props => {
    const { list = [], languageList, onLanguageValueChange, languageValue, onUse } = props;
    const _scrollRef = useRef(null);
    useEffect(() => {
        _scrollRef.current.scrollTop(0);
    }, [languageValue]);

    return (
        <div className={styles.box}>
            <FJHeader title={FJLocalStore._('voice-library')}>
                <div className={styles.search}>
                    <FJSelectWithSearch
                        list={languageList}
                        onLanguageValueChange={onLanguageValueChange}
                        value={languageValue}
                        zIndex={1001}
                        widthStyle={{ width: '320px' }}
                        searchStyle={{ width: '296px' }}
                    />
                </div>
            </FJHeader>
            <FJVerticalScroller className={styles.scroll} ref={_scrollRef}>
                <div className={styles.content}>
                    {list.map(item => {
                        return (
                            <FJVoiceItemContainer
                                info={item}
                                key={item.value}
                                onUse={info => {
                                    onUse(info, { fromType: item.type || FJConstant.MICROSOFT });
                                }}
                                fromType={item.type || FJConstant.MICROSOFT}
                            />
                        );
                    })}
                </div>
            </FJVerticalScroller>
        </div>
    );
};

FJLibrary.propTypes = {
    list: PropTypes.array,
    languageList: PropTypes.array,
    onLanguageValueChange: PropTypes.func,
    languageValue: PropTypes.string,
    onUse: PropTypes.func,
};
export default FJLibrary;
